import { ReactNode } from "react";
import { Link } from "react-router-dom";
import Button, { EButtonSize } from "../Button/Button";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import classes from "./PageHeading.module.scss";

interface IProps {
  children: ReactNode;
  onAdd?: () => void;
  backTo?: string;
}

const PageHeading: React.FC<IProps> = ({ children, onAdd, backTo }) => {
  return (
    <h1 className={classes.PageHeading}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {backTo && (
          <Link
            to={backTo}
            style={{ 
              color: 'inherit',
              textDecoration: 'none',
              fontWeight: 400,
              opacity: 0.6,
              transition: 'opacity 0.2s',
              fontSize: '0.9em'
            }}
            onMouseOver={e => e.currentTarget.style.opacity = '1'}
            onMouseOut={e => e.currentTarget.style.opacity = '0.6'}
          >
            &lt;
          </Link>
        )}
        {children}
      </span>
      {onAdd && (
        <Button
          size={EButtonSize.SMALL}
          onClick={onAdd}
          icon={faPlus}
          style={{ fontSize: "initial" }}
        >
          Add new
        </Button>
      )}
    </h1>
  );
};

export default PageHeading;
